import { io } from "socket.io-client";
import { TokenManager } from "utils/api";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const getSocketOrigin = () => {
    const apiBase = trimTrailingSlash(process.env.REACT_APP_CHAT_API_URL || "");
    if (!apiBase) return undefined;
    try {
        return new URL(apiBase, window.location.origin).origin;
    } catch {
        return apiBase;
    }
};

export const createChatSocket = () => {
    const token = TokenManager.getAccessToken();
    if (!token) return null;
    return io(`${getSocketOrigin() || ""}/chat`, {
        path: "/chat/socket.io",
        transports: ["websocket", "polling"],
        reconnection: true,
        reconnectionAttempts: 5,
        auth: { token },
        withCredentials: true,
    });
};
